import { render, staticRenderFns } from "./AdminProductCategoriesScreen.vue?vue&type=template&id=dd75df38&scoped=true&"
import script from "./AdminProductCategoriesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductCategoriesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd75df38",
  null
  
)

export default component.exports